import TableContainer from 'Common/TableContainer';
import { set } from 'date-fns';
import { addProduct, addProductVariant, getBrands, getCategoryList, getPackagings, getProductList, getProductListByBrand, getProductListByBrandForImages, getProductSizes, getSeasons } from 'helpers/backend_helper';
import { Plus, Search } from 'lucide-react';
import React, { useEffect, useMemo, useState } from 'react';
import * as XLSX from 'xlsx';
import { Loader2 } from "lucide-react";
import { ToastContainer } from 'react-toastify';
import Select from 'react-select';


export const BulkUploadProductImages = () => {

    const [excelData, setExcelData] = useState<any>(null);
    const [productData, setProductData] = useState<any>();
    const [brands, setBrands] = useState<any[]>([]);
    const [keys, setKeys] = useState<any[]>([]);
    const [productList, setProductList] = useState([]);
    const [excelProductList, setExcelProductList] = useState<any[]>([]);
    const [isSaving, setIsSaving] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [selectedBrand, setSelectedBrand] = useState<any>();


    useEffect(() => {
        loadBrands();
    }, [])


    const loadBrands = async () => {
        if (brands.length === 0) {
            const response = await getBrands();
            if (response.success) {
                const brandItems = [{ value: '', label: 'Search by brand' }, ...response.data.map((item: any) => ({ value: item.id, label: item.name }))];
                setBrands(brandItems);

                console.log('brands', brandItems)
            }
        }
    };



    async function loadProducts(item: any) {
        try {
            setIsLoading(true)
            setProductList([]);

            let response = await getProductListByBrandForImages(item.value.toString());
            if (response.success) {
                //console.log('productList', response.data);
                setProductList(response.data as never[]);

                const productsWithoutImages = findProductsWithoutImages(response.data as never[]);

                setExcelProductList(productsWithoutImages);

                // if (productsWithoutImages.length > 0) {
                //     console.log("Products without images:");
                //     productsWithoutImages.forEach(product => console.log(`- ${product.name} (ID: ${product.id})`));
                // } else {
                //     console.log("All products have images.");
                // }

            }
            setIsLoading(false)
        } catch (error) {
            setExcelProductList([]);

        } finally {
            setIsLoading(false)
        }
    }


    function findProductsWithoutImages(products: any[]): any[] {
        return products.filter(product => product.productsProductimages.length === 0);
    }


    const handleAddProduct = () => {

    }

    const borderStyle = {
        border: '1px solid'
    }


    const exportToExcel = () => {

// read name, description, sku and category from the excelProductList and write it to an excel file
        const excelData = excelProductList.map(product => ({
            ProuctName: product.name,
            Description: product.description,
            SKU: product.sku,
            Category: product.categoriesProducts.name
        }));

        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'MissingImages');
        XLSX.writeFile(workbook, `MissingImages-${new Date().toISOString()}.xlsx`);
    };

    return (

        <React.Fragment>
            <ToastContainer closeButton={false} limit={1} />

            <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-12" style={{ marginTop: 15 }}>
                <div className="xl:col-span-12">
                    <div className="card" id="categoriesTable">
                        {/* <div className="card-body  border-y border-dashed "> */}
                        <div className="flex items-center justify-between border-y border-dashed" style={{ padding: 10 }}>
                            <div className="flex justify-start">
                                <h6 className="text-15 grow" style={{ marginRight: 50, marginTop: 10 }}>Product with missing images </h6>
                                <Select
                                    placeholder="Search by brand"
                                    className="border-slate-200 w-80 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                    options={brands}
                                    value={selectedBrand}
                                    defaultValue={selectedBrand}
                                    isSearchable={true} // To disable search
                                    name="brandId"
                                    id="brandId"
                                    onChange={e => { loadProducts(e); }}
                                />
                            </div>
                            <div className="shrink-0">
                                <button type="submit" className="text-white mr-2 transition-all duration-200 ease-linear btn bg-green-500 border-green-500 hover:text-white hover:bg-green-600 hover:border-green-600 focus:text-white focus:bg-green-600 focus:border-green-600 focus:ring focus:ring-green-100 active:text-white active:bg-green-600 active:border-green-600 active:ring active:ring-green-100 dark:ring-green-400/20"
                                    onClick={() => { exportToExcel(); }}
                                >
                                    { "Download Excel"}
                                </button>
                                <button type="button" className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20" onClick={handleAddProduct}>
                                    <Plus className="inline-block size-4" />
                                    <span className="align-middle">Upload Image</span></button>
                            </div>
                        </div>
                        <div style={{ marginTop: 10 }}>
                            {/* <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} /> */}

                            {excelProductList?.length > 0 ? (
                                <>
                                   

                                    <table border={1} style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid', marginTop: 10, marginLeft:10, marginRight:10 }}>
                                        <thead>
                                            <tr>
                                                <th style={borderStyle}>Product Name</th>
                                                <th style={borderStyle}>Description</th>
                                                <th style={borderStyle}>SKU</th>
                                                <th style={borderStyle}>Category</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {excelProductList.map((row, index) => (
                                                <tr key={index}>
                                                    <td style={borderStyle} className={row?.name?.length === 0 || row?.name === "" ? "bg-red-500 border-red-500 text-white-500" : ""}>{row.name}</td>
                                                    <td style={borderStyle} className={row?.description?.length === 0 || row?.description === "" ? "bg-red-500 border-red-500 text-white-500" : ""}>{row.description}</td>
                                                    <td style={borderStyle} className={row?.sku === null || row?.sku === "" ? "bg-red-500 border-red-500 text-white-500" : ""}>{row.sku}</td>
                                                    <td style={borderStyle} className={row.categoryId === 0 || row.categoryId === null ? "bg-red-500 border-red-500 text-white-500" : ""}>{row.categoriesProducts.name}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </>
                            )
                        : (
                            <div style={{ marginTop: 10 , marginLeft:10}}>
                                <h6 className="text-15">No missing images found</h6>
                            </div>
                        )
                        }
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default BulkUploadProductImages;
